module.exports = __webpack_public_path__ + "media/auto_history/odnalezienie-blue-65952325.svg";